import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

export default function NotFound() {
  return (
    <Layout>
      <section
        data-testid="not-found-page"
        className="min-h-[70vh] flex items-center justify-center bg-[#0B0B0C] pt-32 pb-24"
      >
        <div className="text-center px-6">
          <div className="text-[11px] uppercase tracking-[0.4em] text-[#8E9AA6] mb-6">
            404
          </div>
          <h1 className="font-serif text-4xl md:text-6xl font-semibold tracking-tighter text-white">
            That route is off the map.
          </h1>
          <p className="mt-6 text-sm text-[#8E9AA6] font-light">
            The page you're looking for doesn't exist — yet.
          </p>
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="inline-flex mt-10 items-center gap-2 bg-white text-black hover:bg-[#E6E6E6] px-9 py-4 transition-all duration-300 font-medium text-xs tracking-[0.25em] uppercase"
          >
            Return Home
          </Link>
        </div>
      </section>
    </Layout>
  );
}
